module.exports = __webpack_public_path__ + "img/logoVecos.409ff747.svg";